<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CheckModal from "@/components/CheckModal";
import EstiloVidaAPI from "@/services/standards/estiloVida/estiloVidaAPI";
import Table from "@/components/standard/Induction/components/InductionTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";

/**
 * Basic Tables component
 */
export default {
  page: {
    title:
      "3.1.7 Estilo de vida y entornos saludables",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title:
        "3.1.7 Estilo de vida y entornos saludables",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Estilo de vida y entornos saludables",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/estilo-vida`,
        },
        {
          text: "Editar",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: null,
      usersList: [],

      file: null,

      estilo: {
        activity: null,
        scheduled_date: null,
        observations: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      evidencia: {
        evidence: null,
        healthy_environments_id: this.$route.params.id,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      evi: null,
      company: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading1: true,
      item: null,
      itemData: null,
    };
  },
  validations: {
    estilo: {
      employee_id: {
        required,
      },
      activity: {
        required,
      },
      scheduled_date: {
        required,
      },
    },
  },
  methods: {

    dateConvert(date) {
      return dateFormat(date);
    },

    getItemData() {
      ItemAPI.getItems(29)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async uploadDocument() {
      try {
        let name = "";
        let url = "";

        // Si no hay un archivo nuevo seleccionado, usamos el archivo existente
        if (this.file === null) {
          // Comprobamos si ya existe un archivo
          if (this.evidencia.evidence) {
            // Mantener el archivo existente
            name = this.getFile(this.evidencia.evidence)
          } else {
            // Si no hay archivo existente ni uno nuevo, no hacemos nada
            throw new Error("No se ha seleccionado un archivo y no hay un archivo previo.");
          }
        } else {
          // Si se selecciona un nuevo archivo, usamos el nombre del nuevo archivo
          name = this.file.name;
        }

        // Definir la URL basada en el entorno (desarrollo o producción)
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.7/${this.$route.params.id}/3.1.7_evidencia/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.7/${this.$route.params.id}/3.1.7_evidencia/${name}`;
        }

        // Si no se seleccionó un archivo nuevo, simplemente regresamos true
        if (this.file === null) {
          // Mantener la referencia al archivo existente
          return true;
        } else {
          // Cargar el nuevo archivo
          const result = await uploadDocument(url, this.file);
          if (result) {
            // Si la carga es exitosa, actualizar la URL del archivo
            this.evidencia.evidence = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else {
            return false;
          }
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getShow() {
      EstiloVidaAPI.getShow(this.$route.params.id)
        .then((response) => {
          this.evi = response.data.healthy_lifestyle_evidences;
          this.estilo = {
            activity: response.data.activity,
            scheduled_date: response.data.scheduled_date,
            observations: response.data.observations,
            employee_id: response.data.employee_id,
            companies_id: response.data.companies_id,
          };
          this.evidencia.evidence = this.evi[0].evidence
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async save() {
      this.submitted = true;
      this.loading1 = true
      let response = await this.uploadDocument();
      if (response) {
        EstiloVidaAPI.update(this.$route.params.id, {
          activity: this.estilo.activity,
          scheduled_date: this.estilo.scheduled_date,
          observations: this.estilo.observations,
          employee_id: this.estilo.employee_id,
          companies_id: this.estilo.companies_id,
        })
          .then((response) => {
            if (this.evi.length > 0) {
              EstiloVidaAPI.updateEvidence(this.evi[0].id, {
                evidence: this.evidencia.evidence,
                healthy_environments_id: this.evidencia.healthy_environments_id,
                companies_id: this.evidencia.companies_id,
              })
                .then((response) => {
                  const itemChange = {
                    companies_id: this.companyID,
                    item_id: 29,
                    status: 'Pendiente',
                  };
                  newScoresAPI.calculateScores(itemChange)
                    .then((response) => {
                      this.loading1 = false;
                      setTimeout(() => {
                        Swal.fire({
                          title: "¡Éxito!",
                          text: "¡Informacion actualizada con éxito!",
                          type: "success",
                          icon: "success",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                        this.$router.go(-1);
                      }, 1000);
                    })
                    .catch((error) => {
                      this.loading = false
                      setTimeout(() => {
                        Swal.fire({
                          title: "Error",
                          text: "¡No se ha podido registrar!",
                          icon: "error",
                          type: "error",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                        window.location.reload();
                      }, 1000);
                      console.log(error);
                    });
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 29,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.loading1 = false;
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Informacion actualizada con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    this.$router.go(-1);
                  }, 1000);
                })
                .catch((error) => {
                  this.loading = false
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 29)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    goBack() {
      this.$router.go(-1);
    },

  },

  mounted() {
    this.getData();
    this.getItems();
    this.getItemData();
    this.getUsers();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row px-3">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Actividad" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="estilo.activity" maxlength="100">
                    </b-form-textarea>
                    <div v-if="submitted && $v.estilo.activity.$error">
                      <small v-if="!$v.estilo.activity.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-6 px-2" label="Fecha Programada" label-for="trainingDate">
                    <b-form-input type="date" id="trainingDate" v-model="estilo.scheduled_date"
                      :disabled="!allowAccess() || !getRole('Crear')">
                    </b-form-input>
                    <div v-if="submitted && $v.estilo.scheduled_date.$error">
                      <small v-if="!$v.estilo.scheduled_date.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Responsable" label-for="employee">
                    <select id="employeeID" :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="estilo.employee_id" :class="{
                        'is-invalid': $v.estilo.employee_id.$error && submitted,
                      }">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.estilo.employee_id.$error">
                      <small v-if="!$v.estilo.employee_id.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="estilo.observations" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div v-if="this.evi.length > 0" class="form-row col-12 pt-2">
                  <b-form-group class="col-md-12 px-2" label="Subir evidencia" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar"
                      :placeholder="evidencia.evidence ? getFile(evidencia.evidence) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>
                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="!allowAccess() || !getRole('Crear')" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
